/* import __COLOCATED_TEMPLATE__ from './all-versions-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();